(() => {
  /**
   * SECURITY POLICY: Prevent Open Redirect Vulnerabilities
   * * This script sanitizes redirect-related query parameters on sensitive account pages.
   * It ensures that 'return_url' and similar params only point to internal storefront paths,
   * blocking attempts to redirect users to external malicious domains.
   */

  // Target only Shopify account-related routes
  const accountPagePattern = /(^|\/)account\/(login|register|addresses)(\/|$)/;
  if (!accountPagePattern.test(window.location.pathname)) return;

  // Common query parameters used by Shopify or apps to handle post-action navigation.
  const redirectParams = ['return_url', 'return_to', 'redirect', 'redirect_url', 'checkout_url'];
  const currentUrl = new URL(window.location.href);
  let changed = false;

  redirectParams.forEach((param) => {
    const value = currentUrl.searchParams.get(param);
    if (!value) return;

    try {
      /**
       * We resolve the parameter value against the current origin.
       * - If 'value' is a relative path (e.g., "/cart"), it resolves to the current domain.
       * - If 'value' is an absolute URL (e.g., "https://evil.com"), it remains absolute.
       */
      const targetUrl = new URL(value, window.location.origin);

      // If the resolved origin doesn't match our storefront, it's an external (untrusted) link.
      if (targetUrl.origin !== window.location.origin) {
        currentUrl.searchParams.delete(param);
        changed = true;
      }
    } catch {
      // If the URL is malformed and cannot be parsed, remove it as a precaution.
      currentUrl.searchParams.delete(param);
      changed = true;
    }
  });

  if (changed) {
    // Silently update the browser address bar if any malicious params were stripped.
    window.history.replaceState(
      window.history.state,
      '',
      `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`,
    );
  }
})();
